export const PRODUCT_DEMO_BANNER_ID = 'product-demo-banner';
